import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props { children: ReactNode; fallback?: ReactNode; label?: string }
interface State { hasError: boolean }

// Inline (non-full-screen) error boundary: contains a render failure to its own
// subtree — a single version card, a list, a panel — so one piece of bad data
// degrades gracefully while the rest of the screen keeps working. It never blanks
// the whole app the way the top-level boundary does. Use around any list/card
// that renders server data whose shape may vary (e.g. a NULL SharePoint link).
export class InlineErrorBoundary extends Component<Props, State> {
  constructor(props: Props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(): State { return { hasError: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("InlineErrorBoundary caught:", this.props.label || "", error, info);
  }
  render() {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) return this.props.fallback;
      return (
        <div style={{ padding: "10px 14px", margin: "4px 0", border: "1px solid #E0B4B4", background: "#FBEDED", borderRadius: 8, fontSize: 12, color: "#8A4B4B" }}>
          ⚠ {this.props.label || "This section"} couldn't be displayed.
        </div>
      );
    }
    return this.props.children;
  }
}
